module.exports = __webpack_public_path__ + "static/media/BalanceImg.f092fed3.svg";